module.exports = __webpack_public_path__ + "static/media/recording.41dbf543.svg";